import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  ADD_BUTTON: `${cleanedFilename(__filename)}-add-button`,
};
